import ProductUploadItem from './ProductUploadItem'
export default ProductUploadItem
